

/* eslint-disable max-len */
export const winMedia = 'https://media.giphy.com/media/l0FP53519GcImDf1U8/giphy.gif';

export const loseMedia = 'https://media.giphy.com/media/jSPtfWqGxpzigdK24p/giphy.gif';

